import { createMuiTheme } from "@material-ui/core";

export const productReservationTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#8DD9C8',
            contrastText: '#fff',
        },
        secondary: {
            main: '#C94628',
            contrastText: '#fff',
        },
        info: {
            main: '#fffff',
            contrastText: '#fff',
        },

    },
    overrides: {
        MuiSvgIcon: {
            root: { width: 17, height: 17 },
        },
    },
});

export default productReservationTheme;